import cmdHelper from 'bpmn-js-properties-panel/lib/helper/CmdHelper'
import elementHelper from 'bpmn-js-properties-panel/lib/helper/ElementHelper'

import { is } from 'bpmn-js/lib/util/ModelUtil'

let properties = require('bpmn-js-properties-panel/lib/provider/camunda/parts/implementation/Properties')

export default function(group, element, bpmnFactory, translate) {
  if (
    is(element, 'bpmn:ServiceTask') &&
    element.businessObject.class === 'com.beezlabs.camundaengine.async.Appender'
  ) {
    var propertiesEntry = properties(
      element,
      bpmnFactory,
      {
        id: 'properties',
        modelProperties: ['name', 'value'],
        labels: ['State variable name', 'Workflow variable name'],

        getParent: function(element, node, bo) {
          return bo.extensionElements
        },

        createParent: function(element, bo) {
          var parent = elementHelper.createElement(
            'bpmn:ExtensionElements',
            { values: [] },
            bo,
            bpmnFactory
          )
          var cmd = cmdHelper.updateBusinessObject(element, bo, {
            extensionElements: parent
          })
          return {
            cmd: cmd,
            parent: parent
          }
        }
      },
      translate
    )

    if (propertiesEntry) {
      group.entries.push(propertiesEntry)
    }
  }
}
